import React, { useState, useEffect } from 'react';
import './Usrsearch.css';

const Usrsearch = ({ searchTerm, setSearchTerm, suggestions }) => {
  const [showSuggestions, setShowSuggestions] = useState(false);

  useEffect(() => {
    if (searchTerm.length > 0) {
      setShowSuggestions(true);
    } else {
      setShowSuggestions(false);
    }
  }, [searchTerm]);

  return (
    <div className="usearch-bar">
      <div className="ubs">
        <button className="usearch-btn">Search Products</button>
        <input
          type="text"
          placeholder="Search..."
          className="usearch-input"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          onFocus={() => searchTerm && setShowSuggestions(true)}
          onBlur={() => setTimeout(() => setShowSuggestions(false), 150)} // Delay to allow click
        />
        {showSuggestions && suggestions.length > 0 && (
          <ul className="suggestions-dropdown">
            {suggestions.map((item, index) => (
              <li
               key={index}
  onMouseDown={() => {
    setSearchTerm(item);
    setShowSuggestions(false);
  }}
              >
                {item}
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default Usrsearch;
